module.exports = __webpack_public_path__ + "img/Poland.57208dbc.svg";